<template>
 <section class="bg-[#F4F2EE] lg:py-16 sm:py-8">
    <div class="max-w-screen-xl mx-auto">
        <div class="grid grid-cols-12 2xl:px-0 lg:px-4 gap-y-6">

            <div class="order-2 col-span-12 px-6 pb-8 lg:col-span-7 2xl:px-32 md:px-16 lg:py-0 lg:order-1">
                <div class="flex flex-col justify-center h-full xl:pl-16 2xl:pl-0">
                    <h2 class="text-2xl font-bold text-center md:text-3xl lg:text-3xl xl:text-40 xl:leading-10 font-ww-bold md:text-left">
                        {{ heading }}
                    </h2>
                    <div class="mt-4 text-base !leading-5 lg:mt-8 md:text-lg font-ww-regular md:text-left text-center" v-html="description"></div>
                </div>
            </div>

            <div class="order-1 col-span-12 lg:col-span-5 lg:order-2">
                <nuxt-img :src="imageSrc" :alt="imageAlt" width="542" height="534"
                    sizes="xs:330px sm:440px md:760px lg:1023px xl:493px 2xl:989px" loading="lazy" format="webp"
                    class="mx-auto" />
            </div>


        </div>
    </div>
 </section>
</template>

<script setup>
const props = defineProps({
    heading: {
        type: String,
        default: "Chocolate Covered Strawberry"
    },
    description: {
        type: String,
        default: `
     The Nicaraguan rainforest meets pure romance here, as mountain shade grown, premium quality, hand selected coffee cherries are carefully selected to eventually pair with another luxurious cherry, tart and sweet. 
<br><br>
Extracts of delicious dark chocolate hug the flavors of plump tart cherries, swirling amidst the bold yet smooth coffee, a combination that can only be described as luxurious decadence, an amazingly divine cup of confection. 
      `
    },
    imageSrc: {
        type: String,
        default: "/assets/images/chocolate-cake-plate-illustration-images.png"
    },
    imageAlt: {
        type: String,
        default: "Chocolate Covered Strawberry"
    }
});

defineBuilderComponent({
    friendlyName: "InfoWithRightImage",
    inputs: [
        {
            name: "heading",
            type: "string",
            friendlyName: "Heading",
            defaultValue: "Chocolate Covered Strawberry"
        },
        {
            name: "description",
            type: "richText",
            friendlyName: "Description",
            defaultValue: `
     The Nicaraguan rainforest meets pure romance here, as mountain shade grown, premium quality, hand selected coffee cherries are carefully selected to eventually pair with another luxurious cherry, tart and sweet. 
<br><br>
Extracts of delicious dark chocolate hug the flavors of plump tart cherries, swirling amidst the bold yet smooth coffee, a combination that can only be described as luxurious decadence, an amazingly divine cup of confection. 

        `
        },
        {
            name: "imageSrc",
            type: "file",
            friendlyName: "Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/chocolate-cake-plate-illustration-images.png"
        },
        {
            name: "imageAlt",
            type: "string",
            friendlyName: "Image Alt Text",
            defaultValue: "Chocolate Covered Strawberry"
        }
    ]
});
</script>